<div class="container">
  <div class="row justify-content-center">
    <h1>Google Admin Calendar Integration</h1>
    <p>For Internal Use Only.</p>
    <div *ngIf="response">
      {{ response }}
    </div>
  </div>
</div>
